import type { Werkbak } from '../../../../opdrachten/types/Werkbak'
import { DashboardCard } from '../DashboardCard'

interface Props {
  werkbak: Werkbak
  onClickTile: (werkbak: Werkbak) => void
}

export const WerkbakTile = ({ werkbak, onClickTile }: Props) => {
  const { label, count } = werkbak

  return (
    <DashboardCard
      onClick={() => onClickTile(werkbak)}
      label={label}
      count={count}
    />
  )
}
